<template>
  <div style="height: 100%">
    <OnBoardingDialog
      v-if="on_boarding_dialog.open"
      :active="on_boarding_dialog.open"
      :onboarding="on_boarding_dialog.onboarding"
      @close="closeOnBoardingDialog"
    />
    <SignatureDialog v-if="signature_dialog.open" :dialog="signature_dialog" @close="closeSignatureDialog" />
    <v-tabs-items v-model="main_tabs" style="height: inherit !important" :touchless="user && user.role.name === 'operational'">
      <v-tab-item>
        <vue-pull-refresh :on-refresh="onRefresh" :config="config_refresh">
          <div class="yeep-header">
            <v-list-item class="grow">
              <v-list-item-avatar size="46" color="grey lighten-3">
                <v-icon> mdi-account </v-icon>
              </v-list-item-avatar>

              <v-list-item-content v-if="user">
                <v-list-item-subtitle>{{ getWelcomeMessage() }},</v-list-item-subtitle>
                <v-list-item-title>{{ user.name }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-icon v-if="isExtension" icon @click="updateApp()" offset-y class="pr-4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" style="cursor: pointer">mdi-refresh</v-icon>
                  </template>
                  <span>Atualizar serviços</span>
                </v-tooltip>
              </v-list-item-icon>

              <v-list-item-icon class="notification-bell">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openModalNotifications"> mdi-bell </v-icon>
                    <span class="notification-count" v-show="newNotificationsQuantity">{{ newNotificationsQuantity }}</span>
                  </template>
                </v-menu>
              </v-list-item-icon>

              <v-list-item-icon>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on"> mdi-dots-vertical </v-icon>
                  </template>
                  <v-list>
                    <v-list-item v-if="user && user.id === 5004" @click="delete_account_modal = true">
                      <v-list-item-title>Deletar minha conta</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="update()">
                      <v-list-item-title>Atualizar versão</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logout()">
                      <v-list-item-title>Sair</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-icon>
            </v-list-item>
          </div>
        </vue-pull-refresh>
        <ListServiceOrders v-if="!refresh_status" @view="viewServiceOrder" @refresh_app_mode="refreshAppMode" ref="ListServiceOrders" />
      </v-tab-item>
      <v-tab-item>
        <Budget />
      </v-tab-item>
      <v-tab-item>
        <TaskList
          v-if="main_tabs === 2 && user.role.name === 'operational'"
          @return="closeServiceFlow"
          :view_service_order_id="view_service_order_id"
        />
        <ServiceFlow
          v-else-if="main_tabs === 2"
          @return="closeServiceFlow"
          @returnDelete="closeServiceFlow"
          @reset-pending-medias="resetPendingMedias"
          :view_service_order_id="view_service_order_id"
          :should-open-chat="shouldOpenChat"
        />
      </v-tab-item>
      <v-tab-item>
        <Schedule v-if="main_tabs === 3" />
      </v-tab-item>

      <v-tab-item>
        <Records @open-signature-modal="openSignatureModal" @open-onboarding-modal="openOnBoardingDialog" />
      </v-tab-item>
    </v-tabs-items>

    <v-bottom-sheet v-model="delete_account_modal">
      <div class="bottom-sheet-content">
        <div class="bottom-sheet-header">
          <span class="bottom-sheet-title">Deletar conta</span>
          <v-btn icon @click="delete_account_modal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <div class="py-5" style="text-align: center">
          Deseja deletar todos os dados e excluir sua conta?<br />
          <div style="color: red; font-size: 20px; padding-top: 6px">Esta ação não poderá ser desfeita.</div>
        </div>
        <v-btn color="primary" block depressed large @click="logout()">Deletar conta</v-btn>
      </div>
    </v-bottom-sheet>

    <StandardBottomNavigation v-if="main_tabs != 2" :isActive="isOperational || app_mode === 'default'" @update:tab="main_tabs = $event" />
    <AdvancedBottomNavigation v-if="main_tabs != 2" :isActive="!isOperational && app_mode === 'advanced'" @update:tab="main_tabs = $event" />
    <ModalNotifications :is-active="isModalNotificationsActive" @view="viewServiceOrder" @close="closeModalNotifications" />
  </div>
</template>

<script>
import Median from 'median-js-bridge';
import VuePullRefresh from 'vue-pull-refresh';
import ListServiceOrders from '@/components/Home/ListServiceOrders';
import OnBoardingDialog from '@/components/Home/OnBoardingDialog';
import SignatureDialog from '@/components/Home/SignatureDialog/SignatureDialog';
import StandardBottomNavigation from '@/components/BottomNavigation/StandardBottomNavigation';
import AdvancedBottomNavigation from '@/components/BottomNavigation/AdvancedBottomNavigation';
import UserNotificationService from '@/services/api/userNotification';
import Budget from './Budget/Index';
import Records from './Records/Index';
import Schedule from './Schedule/Index';
import ServiceFlow from './ServiceOrder/ServiceFlow';
import ModalNotifications from '../components/Home/ModalNotifications';
import TaskList from './Task/TaskList';

export default {
  name: 'Home',
  components: {
    VuePullRefresh,
    SignatureDialog,
    ServiceFlow,
    Records,
    Schedule,
    Budget,
    ListServiceOrders,
    OnBoardingDialog,
    StandardBottomNavigation,
    AdvancedBottomNavigation,
    ModalNotifications,
    TaskList
  },
  data: () => ({
    main_tabs: 0,
    user: null,
    view_service_order_id: null,
    signature_dialog: {
      open: false,
      email: null
    },
    on_boarding_dialog: {
      open: false,
      onboarding: null
    },
    refresh_status: false,
    config_refresh: {
      errorLabel: '...',
      startLabel: '...',
      readyLabel: 'ATUALIZAR',
      loadingLabel: '...'
    },
    app_mode: 'advanced',
    delete_account_modal: false,
    notifications: [],
    newNotificationsQuantity: 0,
    isModalNotificationsActive: false,
    shouldOpenChat: false,
    userId: null,
    oneSignalId: null
  }),
  computed: {
    update_list() {
      return this.$store.getters['ServiceOrder/update_list'];
    },
    isExtension() {
      return this.$route.query.mode === 'extension';
    },
    newNotifications() {
      return this.notifications.filter((notification) => notification.active);
    },
    isOperational() {
      return this.$store.getters['Auth/user']?.role?.name === 'operational';
    },
  },
  mounted() {
    Median.onesignal.info().then((oneSignalInfo) => {
      this.oneSignalId = oneSignalInfo?.oneSignalId;
      localStorage.setItem('onesignal_id', this.oneSignalId);
    });

    this.$store.dispatch('General/getStatusList');
    this.$store.dispatch('Auth/getDefaultClient');
    this.$store.dispatch('OrganizationServiceOrder/getServiceInformation');

    this.user = this.$store.getters['Auth/user'];

    this.app_mode = localStorage.getItem('app_mode') || 'advanced';
    localStorage.setItem('app_mode', this.app_mode);

    window.vueInstance.$on('view', this.viewServiceOrder);
  },
  beforeDestroy() {
    if (window.vueInstance) {
      window.vueInstance.$off('view', this.viewServiceOrder);
    }
  },
  methods: {
    async openModalNotifications() {
      this.isModalNotificationsActive = true;
    },
    async closeModalNotifications(ids) {
      this.isModalNotificationsActive = false;

      if (ids.length) {
        await this.getNewNotificationsQuantity();
      }
    },
    async getNewNotificationsQuantity() {
      try {
        const { data } = await UserNotificationService.getNewNotificationsQuantity();

        this.newNotificationsQuantity = data.quantity;
      } catch (error) {
        console.log(error);
      }
    },
    onRefresh() {
      this.refresh_status = true;
      setTimeout(() => {
        this.refresh_status = false;
      }, 100);
    },
    refreshAppMode(mode) {
      this.app_mode = mode;
    },
    resetPendingMedias(serviceOrderId) {
      this.$refs.ListServiceOrders.resetPendingMedias(serviceOrderId);
    },
    getOrganizationParameter(code) {
      const { organization } = this.user;
      return organization.parameters.find((parameter) => parameter.code === code).value;
    },
    getWelcomeMessage() {
      const hours = new Date().getHours();

      if (hours >= 18 && hours < 24) {
        return 'Boa noite';
      }

      if (hours >= 12 && hours < 18) {
        return 'Boa tarde';
      }

      if (hours >= 0 && hours < 12) {
        return 'Bom dia';
      }

      return '--';
    },
    viewServiceOrder(service) {
      this.view_service_order_id = service.id;

      this.shouldOpenChat = service.shouldOpenChat;
      this.main_tabs = 2;
    },
    closeServiceFlow(refresh) {
      this.main_tabs = 0;
      this.view_service_order_id = null;
      this.shouldOpenChat = false;
      if (refresh) {
        this.$refs.ListServiceOrders.refreshServiceOrders();
      } else {
        this.$refs.ListServiceOrders.updateItemList(this.update_list);
      }
    },
    async checkOrganizationSignature() {
      const { organization } = this.user;

      if (this.user.organization.onboarding === 0) {
        this.openOnBoardingDialog();
      } else if (organization.organization_signatures.length === 0 && this.user.organization.onboarding === 1) {
        this.signature_dialog = {
          open: true,
          email: this.user.email
        };
      } else if (organization.organization_signatures?.[0].type === 'FREE') {
        const firstDay = new Date(`${organization.organization_signatures?.[0].date}T23:59:59.999Z`);
        const now = new Date();
        const diffInTime = Math.abs(now - firstDay);
        const diffInDays = Math.ceil(diffInTime / (1000 * 60 * 60 * 24));

        if (diffInDays >= 7) {
          this.signature_dialog = {
            open: true,
            email: this.user.email,
            step: 4
          };
        }
      } else if (['pending', 'canceled'].includes(organization.organization_signatures?.[0].status)) {
        this.signature_dialog = {
          open: true,
          step: 4
        };
      }
    },
    openSignatureModal() {
      this.signature_dialog = {
        open: true,
        step: 4
      };
    },
    closeSignatureDialog() {
      this.signature_dialog.open = false;
    },
    async openOnBoardingDialog() {
      const self = this;
      await self.$store.dispatch('Auth/getOnboarding').then(() => {
        self.onboarding = self.$store.getters['Auth/onboarding'];
        self.on_boarding_dialog.onboarding = self.onboarding;
        self.on_boarding_dialog.open = true;
      }).catch((error) => {
        console.error('Erro ao carregar onboarding:', error);
      });
    },
    closeOnBoardingDialog() {
      this.on_boarding_dialog.open = false;
    },
    logout() {
      this.$store.dispatch('Auth/logout');
      this.$router.push('/login');
    },
    update() {
      // eslint-disable-next-line no-undef
      window.median.webview.clearCache();
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },
    updateApp() {
      window.location.reload();
    },
    incrementServiceOrderCount() {
      this.service_order_count += 1;
    }
  },
  watch: {
    user() {
      this.checkOrganizationSignature();

      if (this.user) {
        this.getNewNotificationsQuantity();
      }
    },
    main_tabs(tab) {
      if (this.user.role.name === 'operational' && tab !== 0 && tab !== 2) {
        this.main_tabs = 0;
        return;
      }
      if (tab === 0) {
        this.getNewNotificationsQuantity();
        setTimeout(() => {
          window.scrollTo(0, this.scroll_memory);
        }, 100);
      } else {
        this.scroll_memory = window.scrollY;
      }
    }
  }
};
</script>

<style lang="scss">
.pull-down-container {
  height: inherit !important;

  .pull-down-header {
    background-color: rgb(245, 245, 245) !important;
  }
}

.yeep-header {
  margin-top: 14px;
}

.v-bottom-navigation {
  .v-btn {
    height: auto !important;
    background-color: transparent !important;
    width: 68px !important;
    min-width: 68px !important;

    &::before {
      background-color: transparent !important;
    }

    &.new-action {
      background-color: #48b38b !important;
      border-radius: 16px !important;
      margin-top: -18px;
      margin-left: 10px;
      margin-right: 10px;
      width: 64px !important;
      height: 64px !important;
      max-width: 64px !important;
      max-height: 64px !important;
      min-width: 64px !important;
      min-height: 64px !important;

      img {
        margin-left: 3px;
        opacity: 1 !important;
        top: auto !important;
      }
    }

    .v-btn__content span {
      margin-top: 17px;
    }
  }
}

.notification-bell {
  position: relative;
  display: inline-block;

  .notification-count {
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: red;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
